import React from 'react'
import SearchProduct from '../search-product/SearchProduct'
import SliderWrapper from 'jd-library/SliderWrapper'
import { useDispatch } from 'react-redux'
import { resetSearchData } from '../../actions/products'

const SearchProductsSlider = (props) => {
	const dispatch = useDispatch();
	return (
		<SliderWrapper
			avoidPortal
			onHidden={() => {
				props.onHidden && props.onHidden();
				dispatch(resetSearchData({}));
			}}
		>
			<SearchProduct 
				onProductClick={(productData) => {
					props.onSelectProduct(productData)
				}}
				isPhoto={props.isPhoto}
				readOnlyProduct
				onlyForSelection
				showLeftIcons
			/>
		</SliderWrapper>
	)
}

export default SearchProductsSlider